
import { Badge } from "@/components/ui/badge";

interface ToneBadgeProps {
  tone?: string;
}

const ToneBadge = ({ tone }: ToneBadgeProps) => {
  if (!tone) return null;
  
  const toneLabel = 
    tone === "legal" ? "Legal" :
    tone === "polite" ? "Polite" :
    tone === "aggressive" ? "Assertive" :
    tone === "friendly" ? "Friendly" : tone;
  
  return (
    <Badge 
      variant="outline" 
      className="ml-1 text-xs bg-blue-50 text-blue-700 border-blue-200"
    >
      {toneLabel}
    </Badge>
  );
};

export default ToneBadge;
